module.exports = __webpack_public_path__ + "img/topic_main.18d89888.png";